import { Wrapper, Title } from './styled';
import track from 'react-tracking';
import FollowItem from './FollowItem';
import { useQuery } from '@tanstack/react-query';
import queryFn from './query';
import selector from './selector';

const Follow = () => {
  /** */
  const { data = { keys: [], entities: {} } } = useQuery({
    queryKey: ['DASHBOARD_SUGGESTED_COMPANIES'],
    queryFn,
    staleTime: 3600000,
    select: selector,
  });
  const { keys, entities } = data;
  /** */
  if (keys.length === 0) return null;
  /** */
  return (
    <Wrapper data-cy-id="dashboard-follow">
      <Title>Follow your favorite stocks</Title>
      <ul>
        {keys
          .filter((n) => entities[n])
          .map((n, i) => (
            <FollowItem
              key={`follow-item-${n}`}
              index={i}
              companyId={n}
              canonicalUrl={entities[n].canonicalUrl}
              tickerSymbol={entities[n].tickerSymbol}
              companyName={entities[n].name}
              uniqueSymbol={entities[n].uniqueSymbol}
            />
          ))}
      </ul>
    </Wrapper>
  );
};

export default track(
  {
    type: 'track',
    subject: 'suggestions_module',
    action: 'load',
  },
  { dispatchOnMount: true }
)(Follow) as typeof Follow;
